import React, { useState, useMemo, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

import { GET_FABRIC_DATA } from 'mocks/queries';
import { INSPIRATION_PAGE_SEO_DESCRIPTION } from 'commons/constants';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useScreen from 'hooks/useScreen';
import InspirationPage from './inspiration-page';

const InspirationPhotoGridInner = ({ fabricsData }) => {
  const [mobileItemsPerRow, setMobileItemsPerRow] = useState(3);
  const { isMobile } = useScreen();

  const toggleMobileItemsPerRow = useCallback(() => {
    setMobileItemsPerRow(prevState => {
      const options = [1, 2, 3];
      const indexOfPrev = options.indexOf(prevState);
      return indexOfPrev < options.length - 1
        ? options[indexOfPrev + 1]
        : options[0];
    });
  }, []);

  const seoMeta = useMemo(
    () => ({
      title: 'Customer Photos | Joybird',
      description: INSPIRATION_PAGE_SEO_DESCRIPTION,
      ogTitle: 'Customer Photos by Joybird.com',
      ogUrl: 'https://joybird.com/customer-photos/',
      ogImage:
        'https://joybird2.imgix.net/meta/jb0916-FacebookPageThumbnails-CustomerGallery-v1.jpg?auto=compress,format',
    }),
    []
  );

  return (
    <>
      <Helmet>
        <title>{seoMeta.title}</title>
        <meta name="description" content={seoMeta.description} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoMeta.ogTitle} />
        <meta property="og:description" content={seoMeta.description} />
        <meta property="og:url" content={seoMeta.ogUrl} />
        <meta property="og:image" content={seoMeta.ogImage} />
      </Helmet>

      <InspirationPage
        mobileItemsPerRow={mobileItemsPerRow}
        toggleMobileItemsPerRow={toggleMobileItemsPerRow}
        fabricsData={fabricsData}
        isMobile={isMobile}
      />
    </>
  );
};

InspirationPhotoGridInner.propTypes = {
  fabricsData: PropTypes.array,
};

const InspirationPhotoGrid = props => {
  const { data } = useSuspenseQuery(GET_FABRIC_DATA);
  const fabricsData = data?.getFabrics ?? null;

  return <InspirationPhotoGridInner fabricsData={fabricsData} {...props} />;
};

export default InspirationPhotoGrid;
